/*
 * Copyright (C) 2020-present Borza LLC. All rights reserved.
 */

import { useState } from "react";

import CollectionKind from "../../enums/collection-kind";
import ProductKind from "../../enums/product-kind";
import { addToShopifyCart } from "../../stores/shopify";

const AddToCartButton = ({ collection, product }: { collection: CollectionKind, product: ProductKind }) => {
  const [[quantity], setState] = useState([1]);

  const incrementQuantity = (step: number) => {
    setState([Math.max(quantity + step, 1)]);
  };

  let price = "$0";
  switch (collection) {
    case CollectionKind.Candle:
      price = "$60";
      break;
    case CollectionKind.LipScrub:
      price = "$26";
      break;
    case CollectionKind.LipBalm:
      price = "$20";
      break;
  }

  if (product === ProductKind.TortoiseHandblownGlassCandle ||
      product === ProductKind.RibbedGlassCandle) {
    price = "$120";
  }

  return (
    <div className="sm:text-left text-center">
      <div className="inline-block my-10 mr-5">
        <button
          aria-label="Decrement Quantity"
          className="border border-black font-semibold font-serif hover:border-black hover:text-black inline-block outline-none px-4 py-2 rounded-none text-lg"
          onClick={() => { incrementQuantity(-1); }}
        >
          -
        </button>
        <span className="font-semibold font-serif inline-block mx-3 text-center w-5">{quantity}</span>
        <button
          aria-label="Increment Quantity"
          className="border border-black font-semibold font-serif hover:border-black hover:text-black inline-block outline-none px-4 py-2 rounded-none text-lg"
          onClick={() => { incrementQuantity(+1); }}
        >
          +
        </button>
      </div>
      <button
        aria-label="Add to Cart"
        className="border border-black bg-black cursor-pointer font-semibold font-serif hover:bg-default hover:text-black inline-block outline-none px-4 py-2 rounded-none text-lg text-white uppercase"
        onClick={() => { addToShopifyCart(product, quantity); }}
      >
        Add to Cart: {price}
      </button>
    </div>
  );
};

export default AddToCartButton;
